export default __webpack_public_path__ + "static/media/restringidoGeocercas.d30f91af.svg";